<template>
  <!-- <vs-row vs-justify="center">
    <vs-col type="flex" vs-justify="center" vs-align="center" vs-lg="12" vs-xs="12">
      <vs-card>
        <h3 class="card-title d-flex">Horoscope List</h3>
        <p class="card-subtitle">List of Horoscope with Different Date.</p>
        <br />

        <vs-col vs-lg="6" vs-xs="6" class="mb15 mt20">
          <div>
            <vs-col vs-lg="12" vs-xs="12">
              <div class="upload-btn-wrapper vs-input-primary">
                <label class="vs-input--label">Horoscope CSV file Upload</label>
                <div class="btn">
                  <vs-icon icon="cloud_upload" class="icon-medium"></vs-icon>Upload a file
                </div>
                <input type="file" ref="fileInput" @change="uploadCSV($event)" />
              </div>
            </vs-col>
          </div>
        </vs-col>

        <table class="table" style="text-align:center"></table>
      </vs-card>
    </vs-col>
  </vs-row>-->
  <vs-row vs-justify="center">
    <vs-col
      type="flex"
      vs-justify="center"
      vs-align="center"
      vs-lg="12"
      vs-xs="12"
    >
      <vs-card>
        <h3 class="card-title d-flex">
          Horoscope List
          <vs-button
            class="ml-auto"
            type="filled"
            icon="add_circle"
            @click="addingNewItem"
            size="small"
            >Add New Horoscope</vs-button
          >

          <vs-button
            class="ml-auto"
            type="filled"
            icon="add_circle"
            @click="addNewRashi"
            size="small"
            >Add Latest Rashi File</vs-button
          >
        </h3>
        <!-- <p class="card-subtitle">List of Horoscope with Different Date & Languages.</p> -->
        <!-- <vs-row>
          <vs-col vs-lg="3" vs-xs="12">
            <vs-select
              :color="colorx"
              label="Sorting Type"
              v-model="sorting"
              @change="fileterusingSort($event)"
            >
              <vs-select-item value text="Select Sorting" disabled />
              <vs-select-item value="1" text="Ascending" />
              <vs-select-item value="-1" text="Descending" />
            </vs-select>
          </vs-col>
        </vs-row>-->
        <br />
        <table class="table">
          <tr>
            <th>#</th>
            <!-- <th>Language Name</th> -->
            <th>Language</th>
            <th>File Name</th>
            <th></th>
          </tr>
          <tr v-for="(item, index) in allHoroscopelang" :key="index">
            <td>{{ index + 1 }}</td>
            <!-- <td>{{item.languageName}}</td> -->
            <td>{{ item.language }}</td>
            <td>{{ item.fileName }}</td>
            <td class="td">
              <vs-button
                class="mr15"
                size="small"
                @click="replaceItem(item)"
                color="warning"
                >Replace</vs-button
              >
            </td>
          </tr>
        </table>

     <table class="table">
          <tr>
           <th>#</th>
            <th>Language</th>
            <th>File Name</th>
            <th></th>
          </tr>
          <tr >
            <th>1</th>
            <td>EN</td>
            <td>{{ uploadedFileName }}</td>
            <td class="td">
              <vs-button
                class="mr15"
                size="small"
                @click="addNewRashi()"
                color="warning"
                >Replace</vs-button
              >
            </td>
          </tr>
        </table>
        <!-- Code -->
        <vs-popup
          :title="isNew ? 'Add New Horoscope' : 'Replace Horoscope'"
          :active.sync="defaultalert"
        >
          <vs-row>
            <vs-col vs-lg="12" vs-xs="12" class="mb15 mt20">
              <div>
                <vs-col vs-lg="8" vs-xs="8" class="mb15 mt20" v-if="isNew">
                  <vs-select
                    :color="colorx"
                    label="Horoscope Language"
                    v-model="horoscopeLanguage"
                    icon="arrow_downward"
                  >
                    <vs-select-item value text="Choose Language" disabled />
                    <vs-select-item
                      :value="item.culture"
                      :text="item.culture"
                      v-for="(item, index) in languages"
                      :key="index"
                    />
                  </vs-select>
                </vs-col>
                <vs-col vs-lg="8" vs-xs="8" class="mb15 mt20" v-if="!isNew">
                  <label for>Horoscope Language</label>
                  <br />
                  <b>{{ horoscopeLanguage }}</b>
                </vs-col>

                <vs-col vs-lg="12" vs-xs="12" class="mb15 mt20">
                  <div class="upload-btn-wrapper vs-input-primary">
                    <label class="vs-input--label"
                      >Horoscope CSV file Upload</label
                    >
                    <div class="btn">
                      <vs-icon icon="cloud_upload" class="icon-medium"></vs-icon
                      >Upload a file
                    </div>
                    <input
                      type="file"
                      ref="fileInput"
                      @change="uploadCSV($event)"
                    />
                  </div>
                  <b>{{ fileName }}</b>
                </vs-col>

                <!-- <vs-col vs-lg="11" vs-xs="11">
                  <div class="upload-btn-wrapper vs-input-primary">
                    <b>Music File :</b>
                    <div class="btn">
                      <vs-icon icon="cloud_download" class="icon-medium"></vs-icon>Download file
                    </div>
                    <b>File Name :</b>
                  </div>
                </vs-col>
                <vs-col vs-lg="1" vs-xs="1">
                  <vs-button
                    color="danger"
                    title="Delete File"
                    type="flat"
                    icon="clear"
                    class="closeBtn"
                  ></vs-button>
                </vs-col>-->
              </div>
            </vs-col>
            <vs-col vs-lg="12" vs-xs="12">
              <vs-button @click="btnAddHoroscope">Save</vs-button>
            </vs-col>
          </vs-row>
        </vs-popup>

        <!-- Code -->
        <vs-popup
          :title="'Add New Rashi File'"
          :active.sync="defaultRashialert"
        >
          <vs-row>
            <vs-col vs-lg="12" vs-xs="12" class="mb15 mt20">
              <div>
                <vs-col vs-lg="12" vs-xs="12" class="mb15 mt20">
                  <div class="upload-btn-wrapper vs-input-primary">
                    <label class="vs-input--label"
                      >New Rashi CSV file Upload</label
                    >
                    <div class="btn">
                      <vs-icon icon="cloud_upload" class="icon-medium"></vs-icon
                      >Upload a file
                    </div>
                    <input
                      type="file"
                      ref="fileInput"
                      @change="uploadRashi($event)"
                    />
                  </div>
                  <b>{{ fileName }}</b>
                </vs-col>
              </div>
            </vs-col>
            <vs-col vs-lg="12" vs-xs="12">
              <vs-button @click="btnAddRashi">Save</vs-button>
            </vs-col>
          </vs-row>
        </vs-popup>
      </vs-card>
    </vs-col>
  </vs-row>
</template>

<script>
// import uploader from "../common/uploader.vue";
import api from "@/rest.js";
// import backend from "@/restbackend.js";

import { API } from "@/common/constants";

export default {
  name: "horoscope",
  components: {
    // uploader,
  },
  data: () => ({
    // title: "Post",
    defaultalert: false,
    isNew: true,

    defaultRashialert: false,
    uploadedFileName: "",
    fileData: {},
    fileName: "",
    newRashiFile: "",
    horoscopeLanguage: "",
    horoscopeLanguageName: "",
    languages: [],

    allHoroscopeData: [],
    allHoroscopelang: [],

    colorx: "#0D2144",
    horoData: {
      name: "",
      image: "",
    },
  }),
  methods: {
    fetchAllLanguages() {
      this.$vs.loading();
      api
        .get(API.GET_LANG, {})
        .then((r) => {
          this.$vs.loading.close();
          this.$data.languages = r.data
        })
        .catch(() => {});
    },
    fetchAllHoroscope() {
      this.$vs.loading();
      api
        .get(API.GET_HOROSCOPE, { params: { year: 2020 } })
        .then((r) => {
          this.$vs.loading.close();
          this.$data.allHoroscopeData = r.data.data;
        })
        .catch(() => {});
    },
    fetchHoroscopeLanguages() {
      this.$vs.loading();
      api
        .get(API.GET_HOROSCOPE_LANGUAGES)
        .then((r) => {
          this.$vs.loading.close();

          this.$data.allHoroscopelang = r.data.data;
        })
        .catch(() => {});
    },
    addingNewItem() {
      this.$data.fileData = {};
      this.$data.fileName = "";
      this.$data.horoscopeLanguage = "";
      this.$data.defaultalert = true;
      this.$data.isNew = true;
    },
    addNewRashi() {
      this.$data.fileData = {};
      this.$data.fileName = "";
      this.$data.defaultRashialert = true;
    },
    replaceItem(item) {
      this.$data.horoscopeLanguage = item.language;
      this.$data.defaultalert = true;
      this.$data.isNew = false;
    },

    uploadCSV(data) {
      var splitdata = data.target.files[0].name.split(".");
      const extension = splitdata[splitdata.length - 1];
      if (extension != "json") {
        this.$vs.notify({
          title: "Uploading Error",
          text: "only json fils Require ",
          color: "danger",
          position: "top-right",
        });
        return;
      }
      this.$data.fileData = data.target.files[0];
      this.$data.fileName = this.$data.fileData.name;
      let formdata = new FormData();
      formdata.append("file", this.$data.fileData);
      formdata.append("fileName", this.$data.fileName);
      this.$vs.loading();

      api
        .post(API.UPLOAD_IMAGE, formdata, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          this.$vs.loading.close();
          const fileLength = response.data.files[0].url.split("/");
          this.$data.fileData = fileLength[fileLength.length - 1];
          if (response.data.error != null) {
            this.$vs.loading.close();
            this.$vs.notify({
              title: "Uploading Error",
              text: response.data.error.message,
              color: "danger",
              position: "top-right",
            });
          }
        })
        .catch(() => {});
      this.$vs.loading.close();
    },
    btnAddHoroscope() {
      if (!this.$data.horoscopeLanguage) {
        this.$vs.notify({
          title: "Uploading Error",
          text: "Language Require",
          color: "danger",
          position: "top-right",
        });
        return;
      }
      var lang = this.$data.horoscopeLanguage;
      var result = this.$data.languages.filter(function(item) {
        return item.culture === lang;
      });
      if (result.length) {
        this.$data.horoscopeLanguageName = result[0].language;
      }
      if (!this.$data.fileData || this.$data.fileName == "") {
        this.$vs.notify({
          title: "Uploading Error",
          text: "File Require",
          color: "danger",
          position: "top-right",
        });
        return;
      }

      let formdata = new FormData();
      formdata.append("file", this.$data.fileData);
      formdata.append("filepath", this.$data.fileData);
      formdata.append("fileName", this.$data.fileName);
      this.$vs.loading();

      api
        .post(
          API.UPLOAD_CSV,
          formdata,
          {
            params: {
              language: this.$data.horoscopeLanguage,
              languageName: this.$data.horoscopeLanguageName,
              filepath: this.$data.fileData,
              fileName: this.$data.fileName,
            },
          },
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        )
        .then((response) => {
          if (response.data.error != null) {
            this.$vs.loading.close();
            this.$vs.notify({
              title: "Uploading Error",
              text: response.data.error.message,
              color: "danger",
              position: "top-right",
            });
          } else {
            const data = response;
            if (response) {
              this.$vs.notify({
                text: "File Uploaded",
                color: "success",
                position: "top-right",
              });
              this.$vs.loading.close();
              this.fetchHoroscopeLanguages();
              this.$data.defaultalert = false;
            } else {
              this.$vs.loading.close();
              this.$vs.notify({
                text: "File Uploading Failed",
                color: "danger",
                position: "top-right",
              });
            }
            this.$refs.fileInput.value = null;
            this.$emit("input", data);
          }
        })
        .catch(() => {});
      this.$vs.loading.close();
    },
    btnAddRashi() {
      if (!this.$data.fileData || this.$data.fileName == "") {
        this.$vs.notify({
          title: "Uploading Error",
          text: "File Require",
          color: "danger",
          position: "top-right",
        });
        return;
      }

      let formdata = new FormData();
      formdata.append("file", this.$data.fileData);
      formdata.append("filepath", this.$data.fileData);
      formdata.append("fileName", this.$data.fileName);
      this.$vs.loading();

      api
        .post(
          API.RASHI,
          formdata,
          {
            params: {
              filepath: this.$data.fileData,
              fileName: this.$data.fileName,
            },
          },
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        )
        .then((response) => {
          if (response.data.error != null) {
            this.$vs.loading.close();
            this.$vs.notify({
              title: "Uploading Error",
              text: response.data.error.message,
              color: "danger",
              position: "top-right",
            });
          } else {
            const data = response;
            if (response) {
              this.$vs.notify({
                text: "File Uploaded",
                color: "success",
                position: "top-right",
              });
              this.$vs.loading.close();

              this.$data.defaultRashialert = false;
              this.fetchFileName();
            } else {
              this.$vs.loading.close();
              this.$vs.notify({
                text: "File Uploading Failed",
                color: "danger",
                position: "top-right",
              });
            }
            this.$refs.fileInput.value = null;
            this.$emit("input", data);
          }
        })
        .catch(() => {});
      this.$vs.loading.close();
    },
    uploadRashi(data) {
      var splitdata = data.target.files[0].name.split(".");
      const extension = splitdata[splitdata.length - 1];
      if (extension != "json") {
        this.$vs.notify({
          title: "Uploading Error",
          text: "only json fils Require ",
          color: "danger",
          position: "top-right",
        });
        return;
      }
      let formdata = new FormData();
      this.$data.fileName = data.target.files[0].name;
      formdata.append("file", data.target.files[0]);
      this.$vs.loading();
      api
        .post(API.UPLOAD_IMAGE, formdata, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          if (response.data.error != null) {
            this.$vs.loading.close();
            this.$vs.notify({
              title: "Uploading Error",
              text: response.data.error.message,
              color: "danger",
              position: "top-right",
            });
          } else {
            const data = response;
            const fileLength = response.data.files[0].url.split("/");
            this.$data.fileData = fileLength[fileLength.length - 1];
            this.$data.newRashiFile = response.data.files[0].url;

            if (response) {
              this.$vs.notify({
                text: "File Uploaded",
                color: "success",
                position: "top-right",
              });
              this.$vs.loading.close();
            } else {
              this.$vs.loading.close();
              this.$vs.notify({
                text: "File Uploading Failed",
                color: "danger",
                position: "top-right",
              });
            }
            this.$refs.fileInput.value = null;
            this.$emit("input", data);
          }
        })
        .catch(() => {});
      this.$vs.loading.close();
      // }
    },
    fetchFileName() {
      this.$vs.loading();
      api
        .get(API.RASHI+"/filename", {})
        .then((r) => {
          this.$vs.loading.close();
          this.$data.uploadedFileName = r.data.fileName;
        })
        .catch(() => {});
    },
  },
  mounted() {
    // this.fetchAllPost();
    this.fetchAllLanguages();
    // this.fetchAllHoroscope();
    this.fetchHoroscopeLanguages();
    this.fetchFileName();
  },
};
</script>

<style scoped>
.upload-btn-wrapper {
  position: relative;
  overflow: hidden;
  display: inline-block;
  width: 100%;
  cursor: pointer !important;
}

.btn {
  border: 1px solid rgba(0, 0, 0, 0.2);
  background-color: white;
  padding: 0.4rem;
  border-radius: 0px;
  font-size: 0.85rem;
  width: 100%;
  cursor: pointer;
}

.upload-btn-wrapper input[type="file"] {
  font-size: 100px;
  position: absolute;
  left: 0;
  top: 0;
  opacity: 0;
}
</style>
